import {loadLocaleMessages} from "../../plugins/i18n";

export default {
    namespaced: true,
    state: {
        locale : 'en',
    },
    mutations: {
        changeLocale(state, locale) {
            state.locale = locale;
        }
    },
    actions: {
        changeLocale({commit}, locale){
            commit('changeLocale',locale);
            return loadLocaleMessages(locale);
        },
        setFrameworkToAssessmentLocale({commit,state},assessment){
            let languageid=state.locale;
            if(assessment.languageid){
                languageid=assessment.languageid;
            }else if(assessment.project && assessment.project.default_languageid){
                languageid=assessment.project.default_languageid;
            }
            commit('changeLocale',languageid);
            return loadLocaleMessages(languageid);
        }
    }
}
